export default function ContactPage() {
    return(
        <div Style="margin: 60px;">
            <center>To contact the Apollonius Corp., you can do so utilizing the form below.<br/> <br/><b>NOTE: </b>due to the limited number of personnel in our corporate office, <br/>we are unable to provide a direct response.
            </center>
        </div>
    )
}